import React from 'react'

import type { SelectOption } from '@fourthwall/components'
import { Input, Select } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'

import type {
  CommentsWrittenRule as CommentsWrittenRuleType,
  FormValues,
} from '../../hooks/useBadgeForm/types'
import { FormFields } from '../../hooks/useBadgeForm/types'
import { RuleLayout } from '../RuleLayout'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
  options: SelectOption[]
}

export const CommentsWrittenRule = ({ form, options }: Props) => (
  <RuleLayout
    top={
      <Select
        value={'CommentsWritten' satisfies CommentsWrittenRuleType['type']}
        label="Requirement to earn badge"
        options={options}
        onValueChange={(value) => {
          const newRules = form.values.rules.map((rule) =>
            rule.type === 'CommentsWritten' ? { type: value } : rule,
          )

          form.setFieldValue(FormFields.rules, newRules)
        }}
      />
    }
    bottom={
      <>
        <Input
          {...form.getFieldProps(FormFields.commentsWrittenMin)}
          label="Min. comments number"
        />
        <Input
          {...form.getFieldProps(FormFields.commentsWrittenMax)}
          label="Max. comments number"
          suggestion="Leave empty for infinite"
        />
      </>
    }
    onRemove={() => {
      form.setFieldValue(
        FormFields.rules,
        form.values.rules.filter(
          (rule) => rule.type !== ('CommentsWritten' satisfies CommentsWrittenRuleType['type']),
        ),
      )
    }}
  />
)
